var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8875 170.006L22.85 12.5H177.15L163.094 169.981L99.9062 187.5L36.8875 170.006Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 174.112L151.062 159.956L163.075 25.3812H100V174.112Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 82.4437H125.562L127.325 62.6625H100V43.3438H148.438L147.975 48.525L143.231 101.763H100V82.4437Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.119 132.612L100.031 132.637L78.5187 126.825L77.1438 111.419H57.75L60.4563 141.75L100.025 152.737L100.119 152.712V132.612Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.919 100.944L121.594 126.812L100.05 132.625V152.725L139.65 141.75L139.944 138.487L143.3 100.944H123.919Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.069 43.3438V62.6625H53.4063L53.0188 58.3188L52.1375 48.525L51.675 43.3438H100.069ZM100 82.4437V101.763H78.7563L78.3688 97.4188L77.4938 87.625L77.0313 82.4437H100Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/CSS.bddca13affc5c50ab2f2094968ef9ee4.svg";
export { ForwardRef as ReactComponent };